<div class="m-5">
    <mat-card class="errorPage-card mat-elevation-z8">
        <mat-card-header class="errorPage-cardHeader">
            <mat-card-title><h2>Un-Authorized</h2></mat-card-title>
        </mat-card-header>

        <mat-card-content>
            <div class="font-size-10">
                <div class="text-center">
                    <mat-icon class="errorPage-symbol" [inline]="true">highlight_off</mat-icon>
                </div>

                <div class="text-center pb-5">
                    <span *ngIf="errorMessage" class="text-center font-size-24">
                        {{errorMessage}} Please contact administrator.
                    </span>
                    <span *ngIf="!errorMessage" class="text-center font-size-24">
                        {{defaultErrorMessage}} Please contact administrator.
                    </span>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</div>